module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.offer_config !== null) ? _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "bullhorn"
    }
  }, [_c('div', {
    attrs: {
      "slot": "head"
    },
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.offer_brief.header_title')))]), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "row mt-1"
  }, _vm._l((_vm.fields), function(field) {
    return _c('div', {
      staticClass: "col-md-6 col-sm-6 mt-2"
    }, [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(_vm.$t(("pos.creative.offer_brief." + (field.name)))))]), _c('span', {
      staticClass: "box-widget-list-value"
    }, [_vm._v(_vm._s(_vm.formatFieldValue(_vm.offer_config[field.name], field)))])])
  }))])], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22275dfa"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offer-brief/OfferBrief.vue
// module id = 2021
// module chunks = 1